import { createContext } from 'react';

const ResultadoContext = createContext();

export default ResultadoContext;